import { forwardRef, type HTMLAttributes } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** カードのバリアント */
  variant?: 'default' | 'glass' | 'elevated';
}

/** @graph-connects none */
const variantStyles = {
  default: 'card',
  glass: 'card-glass glass',
  elevated: 'card-elevated',
};

/**
 * @graph-stack mall
 * @graph-domain Operations
 * @graph-business カードコンテナ。default/glass/elevatedバリアント対応。glass morphismスタイルをサポート
 * @graph-connects none
 */
export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ variant = 'default', className = '', children, ...props }, ref) => {
    return (
      <div ref={ref} className={`${variantStyles[variant]} ${className}`} {...props}>
        {children}
      </div>
    );
  },
);

Card.displayName = 'Card';
